import React, { ReactNode, useState } from 'react';
import { makeStyles, Popover } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

export interface InfoPopoverProps {
  children: ReactNode;
  classes?: Partial<ReturnType<typeof useStyles>>;
}

export default function InfoPopover(props: InfoPopoverProps) {
  const {
    children,
  } = props;

  const classes = useStyles(props);

  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const popoverOpen = Boolean(anchorEl);
  const popoverId = popoverOpen ? 'information-popover' : undefined;

  return (
    <>
      <InfoIcon
        aria-owns={popoverOpen ? 'info-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
        className={classes.icon}
      />
      <Popover
        id={popoverId}
        className={classes.popover}
        classes={{ paper: classes.paper }}
        open={popoverOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={() => setAnchorEl(null)}
        disableRestoreFocus
      >
        {children}
      </Popover>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.grey[500],
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
}));
